import "./h2TitleStyle.css"

export default function H2Title({title, color='black'}) {
    return (
        <h2
            className="sub-title-h2"
            style={ {color: color} }
        >
            {title}
        </h2>
    );
}